import axiosInstance from '@/app/api/axiosInstance';
import { Organization, OrganizationCreate, OrganizationUpdate, PaginatedResponse, ListQueryParams } from '@/app/types';

export const listOrganizations = async (params: ListQueryParams): Promise<PaginatedResponse<Organization>> => {
  try {
    console.log('Calling listOrganizations with params:', params);
    // For admin users, this endpoint requires superuser access
    const response = await axiosInstance.get<PaginatedResponse<Organization>>('/organizations/', { params });
    console.log('listOrganizations response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to list organizations:', error);
    throw error;
  }
};

export const getOrganization = async (orgId: number): Promise<Organization> => {
  try {
    console.log(`Calling getOrganization with ID: ${orgId}`);
    // Most users can only access their own organization
    const response = await axiosInstance.get<Organization>(`/organizations/${orgId}`);
    console.log('getOrganization response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to get organization with ID ${orgId}:`, error);
    throw error;
  }
};

export const getCurrentUserOrganization = async (organizationId?: number): Promise<Organization> => {
  try {
    console.log(`Calling getCurrentUserOrganization with ID: ${organizationId}`);
    // Check if organization ID is provided
    if (!organizationId) {
      throw new Error('No organization ID provided');
    }
    
    // Fetch the organization by ID
    return await getOrganization(organizationId);
  } catch (error) {
    console.error('Failed to get current user organization:', error);
    throw error;
  }
};

export const createOrganization = async (data: OrganizationCreate): Promise<Organization> => {
  try {
    console.log('Calling createOrganization with data:', data);
    const response = await axiosInstance.post<Organization>('/organizations/', data);
    console.log('createOrganization response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to create organization:', error);
    throw error;
  }
};

export const updateOrganization = async (orgId: number, data: OrganizationUpdate): Promise<Organization> => {
  try {
    console.log(`Calling updateOrganization with ID: ${orgId}, data:`, data);
    const response = await axiosInstance.patch<Organization>(`/organizations/${orgId}`, data);
    console.log('updateOrganization response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update organization with ID ${orgId}:`, error);
    throw error;
  }
};

export const deleteOrganization = async (orgId: number): Promise<void> => {
  try {
    console.log(`Calling deleteOrganization with ID: ${orgId}`);
    await axiosInstance.delete(`/organizations/${orgId}`);
    console.log('deleteOrganization successful');
  } catch (error) {
    console.error(`Failed to delete organization with ID ${orgId}:`, error);
    throw error;
  }
}; 